import { Directive, input } from '@angular/core';
import { classes } from '@lite-workspace/shared/helm-ui/utils';
import { cva, type VariantProps } from 'class-variance-authority';
import { HlmCardConfig, injectHlmCardConfig } from './hlm-card-token';

export const cardVariants = cva('group/card flex flex-col border border-line2 bg-panel text-ink', {
  variants: {
    variant: {
      default: 'shadow-[var(--shadow-1)]',
      flat: 'shadow-none',
      inset: 'bg-bg2 shadow-none',
    },
    size: {
      default: 'gap-6 rounded-xl py-6',
      sm: 'gap-4 rounded-[var(--r)] p-4',
      xs: 'gap-2 rounded-[var(--r-s)] p-2',
    },
  },
  defaultVariants: { variant: 'default', size: 'default' },
});
export type CardVariants = VariantProps<typeof cardVariants>;

@Directive({
  selector: '[hlmCard],hlm-card',
  host: { 'data-slot': 'card', '[attr.data-size]': 'size()' },
})
export class HlmCard {
  private readonly _defaultConfig = injectHlmCardConfig();
  public readonly variant = input<NonNullable<CardVariants['variant']>>('default');
  public readonly size = input<HlmCardConfig['size']>(this._defaultConfig.size);
  /** On, the card answers the pointer — for a card that is itself a link or a button. */
  public readonly interactive = input(false);

  constructor() {
    classes(() => [
      cardVariants({ variant: this.variant(), size: this.size() }),
      this.interactive() && 'transition-colors duration-[var(--t-fast)] ease-[var(--ease-smooth)] hover:border-acc-line',
    ]);
  }
}
